import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'kwo-snackbar-unlock',
	templateUrl: './snackbar-unlock.component.html',
	styleUrls: ['./snackbar-unlock.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslateModule, FaIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarUnlockComponent implements OnInit {

	constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any,
		public snackBar: MatSnackBar,
		private router: Router) {
	}

	ngOnInit(): void {
	}

	goMembership() {

		this.snackBar.dismiss();
		this.router.navigate(['/aanmelden']);
	}
}